window.addEventListener('DOMContentLoaded', () => {
  setupIntersectionObservers();

  function setupIntersectionObservers() {
    const targets = [
      ...document.querySelectorAll('.fadeInSlideDown'),
      ...document.querySelectorAll('.fadeInSlideLeft'),
      ...document.querySelectorAll('.fadeInSlideRight'),
      ...document.querySelectorAll('.idx-big'),
      ...document.querySelectorAll('.idx-small'),
      document.querySelector('.transition-hero-blur__init'),
      document.querySelector('.transition-123pew__init'),
      document.querySelector('.transition-cascade__init'),
      document.querySelector('.transition-halloween-header__init'),
     ...document.querySelectorAll('.sfp-card'),
      document.querySelector('.pd-grid'),
      ...document.querySelectorAll('.ani-list-products')
    ];
    const finalTargets = targets.filter((ele) => ele !== null);
    if (finalTargets.length === 0) return;

    startObserver(finalTargets);
  }

  function startObserver(targets) {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: (window.innerWidth >= 640 ? 1.0 : 0.25),
    };

    // Add additional setup functions here
    checkSectionListProducts(targets);


    const observer = new IntersectionObserver(handleIntersections, options);
    targets.forEach((target) => (target !== null && observer.observe(target)));

    function handleIntersections(entries) {
      entries.map((entry) => {
        if (
          entry !== null
          && entry.isIntersecting 
          && entry.intersectionRatio >= options.threshold
        ) {
          try {
            const target = entry.target.classList.contains('sfp-card') ? entry.target.firstElementChild : entry.target;
            const completedClass = handleClassList(target);
            (completedClass != '' && target.classList.add(completedClass));
            observer.unobserve(target);
            
          } catch (err) {
            console.error('Intersection Observer Failed Finding Target', err);
          }
        }
      });
    }
  }

  // Additional Setup Functions
  function checkSectionListProducts(targets) {
    const listProducts = targets.filter((ele) => ele && ele.classList.contains('ani-list-products'));
    if (listProducts.length === 0) return;
    
    setupListProducts(listProducts);

    function setupListProducts(listProducts) {
      listProducts.forEach((target, i) => {
        const dir = i % 2 === 0 ? 'ani-slideLeft' : 'ani-slideRight';
        
        target.classList.add(dir);
      });
    }
  }
  
  function handleIndexPrintedProducts(target) {
    const activateProducts = target.querySelectorAll('div.activated');
    if (activateProducts.length === 0) return;
    
    

    activateProducts.forEach((ele, i) => {
      ele.style.transitionDelay = `${i * .2}s`;
      //ele.style.animationDelay = `${i * 1}s`;
      //ele.querySelector('.lc-first').style.animationDelay = `${i * 1}s`;
      
      ele.classList.remove('activated');
      
      setTimeout(() => ele.style.transitionDelay = "0s", 300);
    });
  }

  function handleClassList(target) {
    const classes = target.classList;
    
    if (classes.contains('fadeInSlideDown')) {
      return 'ani__fadeInSlideDown';    
  
    } else if (classes.contains('fadeInSlideLeft')) {
      return 'ani__fadeInSlideLeft';  
  
    } else if (classes.contains('fadeInSlideRight')) {
      return 'ani__fadeInSlideRight';  

    } else if (classes.contains('idx-big')) {
      return 'ani__idx-big'; 
  
    } else if (classes.contains('idx-small')) {
      return 'ani__idx-small';
  
    } else if (classes.contains('transition-hero-blur__init')) {
      return 'transition-hero-blur__complete';
      
    } else if (classes.contains('transition-cascade__init')) {
      return 'transition-cascade__complete';

    } else if (classes.contains('transition-123pew__init')) {
      return 'transition-123pew__complete';

    } else if (classes.contains('transition-halloween-header__init')) {
      return 'transition-halloween-header__complete';
      
    } else if (classes.contains('bubble')) {
      return 'ani__bubble';
      
    } else if (classes.contains('ani-list-products')) {
      return 'animated';

    } else if (classes.contains('pd-grid')) {
      handleIndexPrintedProducts(target);
      return '';

    } else if (classes.contains('ani-list-products')) {
      return 'animated';
    
    } else {
      return '';
    }
  }
});
